<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        BIN
      </h1>
      <ol class="breadcrumb">
        <li>
          <a @click="$router.push({ name: 'dashboard' })">
            <i class="fa fa-dashboard"></i> Dashboard
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'bin-index' })">
            <i class="fa fa-bank"></i> BIN
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <div class="box-title">
            <h3>{{ title }}</h3>
          </div>
        </div>

        <div class="box-body">
          <div class="row">
            <div class="col-12 col-md-12 col-lg-10">
              <div class="form-horizontal">

                <div class="form-group">
                  <label for="bin"
                    class="col-sm-3 control-label">
                    BIN <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      @keydown="isNumber"
                      v-model="form.bin"
                      v-validate="'required|numeric'"
                      data-vv-as="BIN"
                      type="text"
                      id="bin"
                      name="bin"
                      class="form-control"
                      placeholder="BIN Number">
                  </div>
                </div>

                <div class="form-group">
                  <label for="bank-name"
                    class="col-sm-3 control-label">
                    Bank Name <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      v-model="form.bankName"
                      type="text"
                      id="bank-name"
                      name="bank-name"
                      class="form-control"
                      placeholder="Bank Name">
                  </div>
                </div>

                <div class="form-group">
                  <label for="category"
                    class="col-sm-3 control-label">
                    Type <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select
                      id="category"
                      v-model="form.type"
                      :options="lists.type">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="category"
                    class="col-sm-3 control-label">
                    Category <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select
                      id="category"
                      v-model="form.category"
                      :options="lists.category">
                    </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="card-series"
                    class="col-sm-3 control-label">
                    Card Series <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      v-model="form.cardSeries"
                      type="text"
                      id="card-series"
                      name="card-series"
                      class="form-control"
                      placeholder="Card Series Name">
                  </div>
                </div>

                <div class="form-group">
                  <label for="status"
                    class="col-sm-3 control-label">
                    Status
                  </label>

                  <div class="col-sm-9">
                    <v-select
                      id="status"
                      name="status"
                      v-model="form.isEnabled"
                      :options="lists.statuses">
                    </v-select>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="box-footer">
          <button class="btn btn-info pull-right"
            @click="submit">
            <template v-if="isCreate">Create</template>
            <template v-else>Update</template>
          </button>

          <a class="btn btn-default"
            @click.prevent="cancel">
            Cancel
          </a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Common from '@/mixins/Common';

export default {
  name: 'BinForm',

  mixins: [Common],

  data() {
    return {
      title: 'Create BIN',
      form: {
        bin: null,
        bankName: null,
        type: null,
        category: null,
        cardSeries: null,
        isEnabled: {
          label: 'Active',
          value: 1,
        },
      },

      lists: {
        category: [],

        type: [
          {
            label: 'Credit',
            value: 'credit',
          },
          {
            label: 'Debit',
            value: 'debit',
          },
        ],

        statuses: [
          {
            label: 'Active',
            value: 1,
          },
          {
            label: 'Inactive',
            value: 0,
          },
        ],
      },
    };
  },

  props: {
    isCreate: {
      type: Boolean,
      required: false,
    },
  },

  methods: {
    getCreditCards() {
      return new Promise((resolve, reject) => {
        this.axios.get('/payments/creditcard')
          .then((response) => {
            const { data } = response.data;
            data.forEach((item) => {
              this.lists.category.push({
                label: item.name,
                value: item.id,
              });
            });
            resolve();
          })
          .catch((error) => {
            this.$swal({
              title: 'Failed',
              text: 'Failed to fetch available cards',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.getCreditCards();
              }
            });

            reject(new Error(error));
          });
      });
    },

    fetch() {
      this.axios.get(`/payments/bin/${this.$route.params.id}`)
        .then((response) => {
          const { data } = response.data;

          let categoryData = {};
          this.lists.category.forEach((item) => {
            if (item.value === data.category) {
              categoryData = item;
            }
          });

          let typeData = {};
          this.lists.type.forEach((item) => {
            if (item.value === data.type) {
              typeData = item;
            }
          });

          let enabled = {};
          this.lists.statuses.forEach((item) => {
            if (item.value === data.is_enabled) {
              enabled = item;
            }
          });

          this.form.bin = data.bin;
          this.form.bankName = data.bank_name;
          this.form.cardSeries = data.card_series;
          this.form.category = categoryData;
          this.form.type = typeData;
          this.form.isEnabled = enabled;
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.errors = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Failed',
              text: 'Failed to fetch BIN detail',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.fetch();
              }
            });
          }
        });
    },

    async init() {
      await this.getCreditCards();

      if (!this.isCreate) {
        await this.fetch();
      }
    },

    prepareValues(arr) {
      if (!arr) return [];

      // Make sure object is array
      const isItArray = Array.isArray(arr);
      if (!isItArray) {
        arr = [arr];
      }

      // Return only value
      const values = [];
      arr.forEach((item) => {
        values.push(item.value);
      });

      return values;
    },

    isNumber(event) {
      const charCode = (event.which) ? event.which : event.keyCode;

      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault();
      }

      return true;
    },

    validate() {
      if (!this.form.bin) {
        this.$swal('BIN required', 'Please fill BIN number to continue', 'warning');
        return false;
      }

      if (!this.form.bankName) {
        this.$swal('Bank name required', 'Please fill bank name to continue', 'warning');
        return false;
      }

      if (!this.form.type || this.form.type.length < 1) {
        this.$swal('BIN type required', 'Please select BIN type to continue', 'warning');
        return false;
      }

      if (!this.form.category || this.form.category.length < 1) {
        this.$swal('BIN category required', 'Please select BIN category to continue', 'warning');
        return false;
      }

      if (!this.form.cardSeries) {
        this.$swal('BIN card series required', 'Please select BIN card series to continue', 'warning');
        return false;
      }

      if (!this.form.isEnabled) {
        this.$swal('BIN status required', 'Please select BIN status to continue', 'warning');
        return false;
      }

      return true;
    },

    submit() {
      const result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    create() {
      const data = {
        bin: this.form.bin,
        bank_name: this.form.bankName,
        card_series: this.form.cardSeries,
        category: this.form.category.value,
        bin_type: this.form.type.value,
        is_enabled: this.form.isEnabled.value,
      };

      return this.axios.post('/payments/bin', this.stringify(data))
        .then(() => {
          this.$swal({
            title: 'Created',
            text: 'Bin has been created.',
            type: 'success',
            timer: 3000,
          });

          this.$router.push({ name: 'bin-index' });
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.error = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Create Failed!',
              text: 'Failed to create new BIN',
              type: 'warning',
              timer: 5000,
            });
          }
        });
    },

    update() {
      const data = {
        bin: this.form.bin,
        bank_name: this.form.bankName,
        card_series: this.form.cardSeries,
        category: this.form.category.value,
        bin_type: this.form.type.value,
        is_enabled: this.form.isEnabled.value,
      };

      return this.axios.put(`/payments/bin/${this.$route.params.id}`, this.stringify(data))
        .then(() => {
          this.$swal({
            title: 'Updated',
            text: 'Bin has been updated.',
            type: 'success',
            timer: 3000,
          });

          this.$router.push({ name: 'bin-index' });
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.error = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Update Failed!',
              text: 'Failed to update BIN',
              type: 'warning',
              timer: 5000,
            });
          }
        });
    },

    cancel() {
      this.$router.go(-1);
    },
  },

  created() {
    this.init();

    if (!this.isCreate) {
      this.title = 'Edit BIN';
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/operation/bin/Form.vue